import * as vehicleTypes from 'commons-vehicle/Vehicle/actions/vehicleActionTypes.js';

export function setVehicle(vehicle) {
    return { type: vehicleTypes.SET_VEHICLE, vehicle };
}

export function setPurchaseMethods(purchaseMethods) {
    return { type: vehicleTypes.SET_VEHICLE_PURCHASE_METHODS, purchaseMethods };
}

export default {
    setVehicle,
    setPurchaseMethods,
};



// WEBPACK FOOTER //
// ./src/Vehicle/actions/vehicleActions.js